export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/bike/resources/components.js